<template>
	<modal
		:exibir="exibir"
		:titulo="tituloModal"
		:max-width="modalOptions.largura"
		@close="fecharModal"
		:custom-actions="true"
		cor-do-botao-confirmar="error"
		nome-botao-confirmar="Confirmar"
	>
		<template #body>
			<v-row class="mb-sm-6 mx-0 my-4 no-gutters">
				<v-col cols="12" class="d-flex flex-column text-sm-start text-start me-0" sm="6">
					<span class="primary--text tamanho-texto-titulo">Principal</span>

					<span class="d-flex flex-sm-row align-center align-content-center">
						<v-avatar color="grey lighten-2" left size="19" class="estilo-avatar me-2">
							{{ fornecedoresDoItem.principal.classificacao }}º</v-avatar
						>
						<texto-tooltip
							:tamanho-maximo="tamanhoMaximo"
							color-button="colorButton"
							:texto="fornecedoresDoItem.principal.razaoSocial"
						></texto-tooltip>
					</span>
				</v-col>

				<v-col cols="12" sm="3" class="d-flex flex-column text-sm-start text-start me-0">
					<span class="primary--text tamanho-texto-titulo">Marca</span>
					<span>
						<texto-tooltip
							:tamanho-maximo="tamanhoMaximo"
							color-button="colorButton"
							:texto="fornecedoresDoItem.principal.marca"
						></texto-tooltip>
					</span>
				</v-col>
				<v-col cols="12" class="d-flex flex-column text-sm-end text-start me-0" sm="3">
					<span class="primary--text tamanho-texto-titulo float-sm-right me-0">Valor</span>
					<span class="float-sm-right me-0">
						{{ fornecedoresDoItem.principal.valorUnitario | azCurrency(numeroCasasDecimaisValores) }}
					</span>
				</v-col>
			</v-row>

			<div>
				<v-simple-table>
					<template #default>
						<thead>
							<tr>
								<th class="ps-0 text-left primary--text">Cadastros Reservas</th>
								<th class="text-left primary--text">Marca</th>
							</tr>
						</thead>
						<tbody>
							<tr
								v-for="aderente in fornecedoresDoItem.aderentes"
								:key="aderente.id"
								class="cor-fonte-tr"
							>
								<td class="ps-0">
									<v-avatar color="grey lighten-2" left size="19" class="estilo-avatar me-2">
										{{ aderente.classificacao }}º
									</v-avatar>
									{{ aderente.razaoSocial }}
								</td>
								<td>{{ aderente.marca }}</td>
							</tr>
						</tbody>
					</template>
				</v-simple-table>
			</div>
		</template>
	</modal>
</template>

<script>
export default {
	name: 'modal-fornecedores-aderentes',
	props: {
		exibir: {
			type: Boolean,
		},
		fornecedoresDoItem: {
			type: Object,
			default() {
				return {}
			},
		},
	},
	data() {
		return {
			tituloModal: 'Fornecedores',
			modalOptions: {
				largura: '600',
			},
			tamanhoMaximo: 50,
		}
	},
	computed: {
		numeroCasasDecimaisValores: {
			get() {
				return this.$store.state.ata.informacoesAta.numeroCasasDecimaisValores
			},
		},
	},
	methods: {
		fecharModal() {
			this.$emit('fechar-modal')
		},
	},
}
</script>

<style lang="stylus" scoped>

.tamanho-texto-titulo
	font-size 15px !important
	font-weight: bold

.estilo-avatar
	font-size 10px !important
	font-weight bold
	color black

.cor-fonte-tr
	color #00000099
</style>
